import { ColorField as AriaColorField, type ColorFieldProps as AriaColorFieldProps, composeRenderProps } from 'react-aria-components';
import { cn } from '../../../components/utils';
import { FieldLabel } from '../base-controls/FieldLabel';
import { FieldDescription } from '../base-controls/FieldDescription';
import { FieldError } from '../base-controls/FieldError';
import { TextInput } from '../base-controls/text-controls/TextInput';
import { baseControlStyles } from '../base-controls/util';

export interface ColorFieldProps extends AriaColorFieldProps {
	label?: string;
	description?: string;
	errorMessage?: string;
}

export function ColorField({ label, description, errorMessage, ...props }: ColorFieldProps) {
	const { base } = baseControlStyles();
	return (
		<AriaColorField {...props} className={composeRenderProps(props.className, className => cn(base(), className))}>
			{label && <FieldLabel>{label}</FieldLabel>}
			<TextInput />
			{description && <FieldDescription>{description}</FieldDescription>}
			{errorMessage && <FieldError errorMessage={errorMessage} />}
		</AriaColorField>
	);
}
